import { scrollTo } from "@common/scrollerHelper"

export const scrollDown = (parent: HTMLElement, cardClass: string, $el: HTMLElement, duration = 500, delay = 350) => {
    setTimeout(() => {
        const children = parent.getElementsByClassName(cardClass);
        const lastCardHeight = children.length ? children[children.length - 1].clientHeight : 200;
        const to = (parent.offsetHeight - lastCardHeight) + parent.offsetTop;
        scrollTo($el, to, duration);
    }, delay)
}